import { Database } from 'lucide-react';

export const SidebarKnowledgeBasesSection = ({ knowledgeBases, selectedKB, onSelectKB }) => (
  <div className="space-y-4">
    <div className="w-full">
      <img src="/logo-braux.png" alt="Braux Paysagistes" className="mb-6 w-full" />
    </div>

    <h3 className="text-xs font-mono uppercase tracking-widest text-muted-foreground/60">
      Bases de connaissances
    </h3>

    <div className="space-y-2" data-testid="knowledge-bases-list">
      {knowledgeBases.map((kb) => (
        <button
          key={kb.id}
          data-testid={`kb-${kb.id}`}
          onClick={() => onSelectKB(kb)}
          className={`w-full rounded-sm border p-3 text-left transition-all duration-300 ${
            selectedKB?.id === kb.id
              ? 'border-white bg-white/10'
              : 'border-zinc-800 bg-transparent hover:border-white hover:bg-zinc-900/50'
          }`}
        >
          <div className="flex items-center gap-3">
            <Database className="h-4 w-4 flex-shrink-0" />
            <div className="flex min-w-0 flex-1 items-center justify-between">
              <div className="truncate font-medium">{kb.name}</div>
              <div className="ml-2 whitespace-nowrap text-xs text-muted-foreground">
                {kb.document_count || 0} {kb.document_count <= 1 ? 'document' : 'documents'}
              </div>
            </div>
          </div>
        </button>
      ))}
    </div>
  </div>
);
